import { without } from 'lodash-es';

export const QUESTIONS_AND_ANSWERS: string[] = [
  'howOurAppDiffer',
  'isFreeOfCharge',
  'isCvRequired',
  'whichFacilitiesOfferJobs',
  'otherPopularJobTitles',
  'otherPopularLocations',
];

export const JOB_LISTING_FAQS_BY_VARIANT = {
  jobAndLocation: QUESTIONS_AND_ANSWERS,
  locationOnly: without(QUESTIONS_AND_ANSWERS, 'otherPopularJobTitles'),
  positionOnly: without(QUESTIONS_AND_ANSWERS, 'otherPopularLocations'),
} as const;

export type JobListingFaqVariant = keyof typeof JOB_LISTING_FAQS_BY_VARIANT | 'none';

const SCHEMA_PLACEHOLDER_TAGS = new Set(['RelatedLocations', 'RelatedJobTitles', 'magazinJobApplicationTips']);
const SCHEMA_TAG_REGEX = /<\/?([A-Za-z][A-Za-z0-9]*)\s*\/?>/g;

export const stripFormattingTagsForSchema = (text: string) =>
  text.replaceAll(SCHEMA_TAG_REGEX, (match, tagName: string) => (SCHEMA_PLACEHOLDER_TAGS.has(tagName) ? match : ''));
